import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";

// Reusable fetch function with token
const fetchData = async (url) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

export const useFilterStore = create((set) => ({
  filter: {
    vehicleNumber: "",
    zoneId: "",
    circleId: "",
    collectionTypeId: "",
    vehicleTypeId: "",
  },
  loading: false,
  zones: [],
  circles: [],
  allCircles:[],
  collectionTypes: [],
  vehicleTypes: [],
  ownerTypes: [],

  setFilterField: (field, value) => {
    set((state) => ({
      filter: { ...state.filter, [field]: value },
    }));
  },

  // Fetch zones
  fetchFilterZones: async () => {
    // set({ loading: true });
    const data = await fetchData(`${API_BASE_URL1}MasterDetails/GetAllZone`);
    set({ zones: data });
  },

  // Fetch circles based on zoneId
  fetchFilterCircles: async (zoneId) => {
    // set({ loading: true });
    const data = await fetchData(
      `${API_BASE_URL1}MasterDetails/GetCircleByZoneId?ZoneId=${zoneId}`
    );
    set({ circles: data });
  },

    fetchAllCircles: async (zoneId) => {
    // set({ loading: true });
    const data = await fetchData(
      `${API_BASE_URL1}MasterDetails/GetAllCircles`
    );
    set({ allCircles: data });
  },

  // Fetch collection types
  fetchFilterCollectionTypes: async () => {
    // set({ loading: true });
    const data = await fetchData(
      `${API_BASE_URL1}MasterDetails/GetAllCollectionType`
    );
    set({ collectionTypes: data });
  },

  // Fetch vehicle types based on collectionTypeId
  fetchFilterVehicleTypes: async (collectionTypeId) => {
    // set({ loading: true });
    const data = await fetchData(
      `${API_BASE_URL1}MasterDetails/GetAllVehicleTypeByCollectionType?CollectionTypeId=${collectionTypeId}`
    );
    set({ vehicleTypes: data });
  },

  // Fetch owner types
  fetchFilterOwnerTypes: async () => {
    // set({ loading: true });
    const data = await fetchData(
      `${API_BASE_URL1}MasterDetails/GetAllOwnerTypes`
    );
    set({ ownerTypes: data });
  },

  // Reset filters
  resetFilters: () => {
    set({
      filter: {
        vehicleNumber: "",
        zoneId: "",
        circleId: "",
        collectionTypeId: "",
        vehicleTypeId: "",
      },
      circles: [],
      vehicleTypes: [],
    });
  },
}));


// import { create } from "zustand";
// import axios from "axios";
// import { API_BASE_URL1 } from "../../../Services/baseApiUrl";

// // In-memory cache for fetchData
// const cache = {};
// const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

// // Reusable fetch function with token and caching
// const fetchData = async (url) => {
//   // Check for valid cached response
//   if (cache[url] && Date.now() - cache[url].timestamp < CACHE_DURATION) {
//     // console.log("Returning cached response for:", url);
//     return cache[url].data;
//   }

//   const token = localStorage.getItem("token");
//   try {
//     const response = await axios.get(url, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     // Store response in cache
//     cache[url] = {
//       data: response.data,
//       timestamp: Date.now(),
//     };

//     return response.data;
//   } catch (error) {
//     console.error("Error fetching data:", error);
//     return [];
//   }
// };

// export const useFilterStore = create((set) => ({
//   filter: {
//     vehicleNumber: "",
//     zoneId: "",
//     circleId: "",
//     collectionTypeId: "",
//     vehicleTypeId: "",
//   },
//   loading: false,
//   zones: [],
//   circles: [],
//   collectionTypes: [],
//   vehicleTypes: [],
//   ownerTypes: [],

//   setFilterField: (field, value) => {
//     set((state) => ({
//       filter: { ...state.filter, [field]: value },
//     }));
//   },

//   fetchFilterZones: async () => {
//     set({ loading: true });
//     const data = await fetchData(`${API_BASE_URL1}MasterDetails/GetAllZone`);
//     set({ zones: data, loading: false });
//   },

//   fetchFilterCircles: async (zoneId) => {
//     set({ loading: true });
//     const data = await fetchData(
//       `${API_BASE_URL1}MasterDetails/GetCircleByZoneId?ZoneId=${zoneId}`
//     );
//     set({ circles: data, loading: false });
//   },

//   fetchFilterCollectionTypes: async () => {
//     set({ loading: true });
//     const data = await fetchData(
//       `${API_BASE_URL1}MasterDetails/GetAllCollectionType`
//     );
//     set({ collectionTypes: data, loading: false });
//   },

//   fetchFilterVehicleTypes: async (collectionTypeId) => {
//     set({ loading: true });
//     const data = await fetchData(
//       `${API_BASE_URL1}MasterDetails/GetAllVehicleTypeByCollectionType?CollectionTypeId=${collectionTypeId}`
//     );
//     set({ vehicleTypes: data, loading: false });
//   },

//   fetchFilterOwnerTypes: async () => {
//     set({ loading: true });
//     const data = await fetchData(
//       `${API_BASE_URL1}MasterDetails/GetAllOwnerTypes`
//     );
//     set({ ownerTypes: data, loading: false });
//   },

//   resetFilters: () => {
//     set({
//       filter: {
//         vehicleNumber: "",
//         zoneId: "",
//         circleId: "",
//         collectionTypeId: "",
//         vehicleTypeId: "",
//       },
//       circles: [],
//       vehicleTypes: [],
//     });
//   },
// }));